/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

export const types = {
  FETCH_COMPANIES: "[Company] Fetch companies",
  FETCH_COMPANIES_SUCCESS: "[Company] Fetch companies success",
  FETCH_COMPANIES_FAILED: "[Company] Fetch companies failed",

  FETCH_ALL_COMPANIES: "[Company] Fetch all companies",
  FETCH_ALL_COMPANIES_SUCCESS: "[Company] Fetch all companies success",
  FETCH_ALL_COMPANIES_FAILED: "[Company] Fetch all companies failed",

  FETCH_A_COMPANY: "[Company] Fetch a Company",
  FETCH_A_COMPANY_SUCCESS: "[Company] Fetch a Company success",
  FETCH_A_COMPANY_FAILED: "[Company] Fetch a Company failed",

  CREATE_COMPANY: "[Company] Create Company",
  CREATE_COMPANY_SUCCESS: "[Company] Create Company success",
  CREATE_COMPANY_FAILED: "[Company] Create Company failed",

  REMOVE_COMPANY: "[Company] Remove current company",

  UPDATE_COMPANY: "[Company] Update Company",
  UPDATE_COMPANY_SUCCESS: "[Company] Update Company success",
  UPDATE_COMPANY_FAILED: "[Company] Update Company failed",

  DISABLE_COMPANY: "[Company] Disable current Company",
  DISABLE_COMPANY_SUCCESS: "[Company] Disable current Company success",
  DISABLE_COMPANY_FAILED: "[Company] Disable current Company failed",

  ENABLE_COMPANY: "[Company] Enable current Company",
  ENABLE_COMPANY_SUCCESS: "[Company] Enable current Company success",
  ENABLE_COMPANY_FAILED: "[Company] Enable current Company failed",

  SET_DEFAULT_COMPANY: "[Company] Set Default Company",

  DELETE_COMPANY: "[Company] Delete current Company",
  DELETE_COMPANY_SUCCESS: "[Company] Delete current Company success",
  DELETE_COMPANY_FAILED: "[Company] Delete current Company failed",

  STAR_COMPANY: "[Company] Star Company",
  STAR_COMPANY_SUCCESS: "[Company] Star Company success",
  STAR_COMPANY_FAILED: "[Company] Star Company failed",

  UN_STAR_COMPANY: "[Company] UnStar Company",
  UN_STAR_COMPANY_SUCCESS: "[Company] UnStar Company success",
  UN_STAR_COMPANY_FAILED: "[Company] UnStar Company failed",

  CLEAR_COMAPANY_LIST: "[Company] Clear Company list",

  SWITCH_COMAPANY: "[Company] Switch Company",
  SWITCH_COMAPANY_SUCCESS: "[Company] Switch Company Success",
  SWITCH_COMAPANY_FAILED: "[Company] Switch Company failed",

  CLEAR_COMPANY_RESPONSE: "[Company] Clear Company Response",

  FETCH_A_COMPANY_LOGS: "[Company] Fetch a Company Logs",
  FETCH_A_COMPANY_LOGS_SUCCESS: "[Company] Fetch a Company Logs Success",
  FETCH_A_COMPANY_LOGS_FAILED: "[Company] Fetch a Company Logs failed",

  CLEAR_COMPANY_DETAILS: "[Company] Clear Company Details",

  UPDATE_COMPANY_FEATURE: "[Company] Update Company Feature",
  UPDATE_COMPANY_FEATURE_SUCCESS: "[Company] Update Company Feature success",
  UPDATE_COMPANY_FEATURE_FAILED: "[Company] Update Company Feature failed",

  FETCH_COMPANY_FEATURE_LIST: "[Company] Fetch Company Feature List",
  FETCH_COMPANY_FEATURE_LIST_SUCCESS:
    "[Company] Fetch Company Feature List Success",
  FETCH_COMPANY_FEATURE_LIST_FAILED:
    "[Company] Fetch Company Feature List Failed",
  UPDATE_COMPANY_DYNAMIC: "[Company] Update Company Dynamic",
  UPDATE_COMPANY_DYNAMIC_SUCCESS: "[Company] Update Company Dynamic Success",
  UPDATE_COMPANY_DYNAMIC_FAILED: "[Company] Update Company Dynamic Failed",
  CLEAR_ERROR_RESPONSE: "[Company] Clear Error Response",
};

//
// ─── FETCH ALL COMPANIES ACTIONS ────────────────────────────────────────────────
//
export const FetchCompanies = (
  status,
  page,
  size,
  order,
  query,
  field,
  filters,
) => ({
  type: types.FETCH_COMPANIES,
  payload: {
    status,
    page,
    size,
    order,
    query,
    field,
    filters,
  },
});
export const FetchCompaniesSuccess = (list) => ({
  type: types.FETCH_COMPANIES_SUCCESS,
  payload: list,
});
export const FetchCompaniesFailed = (error) => ({
  type: types.FETCH_COMPANIES_FAILED,
  payload: error,
});
//
// ─── FETCH ALL COMPANIES ACTIONS ────────────────────────────────────────────────
//
export const FetchAllCompanies = (status, page, size, order, query, field) => ({
  type: types.FETCH_ALL_COMPANIES,
  payload: {
    status,
    page,
    size,
    order,
    query,
    field,
  },
});
export const FetchAllCompaniesSuccess = (list) => ({
  type: types.FETCH_ALL_COMPANIES_SUCCESS,
  payload: list,
});
export const FetchAllCompaniesFailed = (error) => ({
  type: types.FETCH_ALL_COMPANIES_FAILED,
  payload: error,
});
//
// ─── FETCH A COMPANY ACTIONS ────────────────────────────────────────────────────
//

export const FetchACompany = (id) => ({
  type: types.FETCH_A_COMPANY,
  payload: id,
});
export const FetchACompanySuccess = (list) => ({
  type: types.FETCH_A_COMPANY_SUCCESS,
  payload: list,
});
export const FetchACompanyFailed = (error) => ({
  type: types.FETCH_A_COMPANY_FAILED,
  payload: error,
});
//
// ─── CREATE COMPANY ACTIONS ─────────────────────────────────────────────────────
//
export const CreateCompany = (company) => ({
  type: types.CREATE_COMPANY,
  payload: company,
});
export const CreateCompanySuccess = (response) => ({
  type: types.CREATE_COMPANY_SUCCESS,
  payload: response,
});
export const CreateCompanyFailed = (error) => ({
  type: types.CREATE_COMPANY_FAILED,
  payload: error,
});
//
// ─── REMOVE SINGLE COMPANY ACTIONS ────────────────────────────────────────────────────
//

export const RemoveCompany = (id) => ({
  type: types.REMOVE_COMPANY,
  payload: id,
});
//
// ─── UPDATE COMPANY ACTIONS ─────────────────────────────────────────────────────
//
export const UpdateCompany = (company) => ({
  type: types.UPDATE_COMPANY,
  payload: company,
});
export const UpdateCompanySuccess = (response) => ({
  type: types.UPDATE_COMPANY_SUCCESS,
  payload: response,
});
export const UpdateCompanyFailed = (error) => ({
  type: types.UPDATE_COMPANY_FAILED,
  payload: error,
});

//
// ─── DISABLE COMPANY ACTIONS ────────────────────────────────────────────────────
//

export const DisableCompany = (id) => ({
  type: types.DISABLE_COMPANY,
  payload: id,
});
export const DisableCompanySuccess = (response) => ({
  type: types.DISABLE_COMPANY_SUCCESS,
  payload: response,
});
export const DisableCompanyFailed = (error) => ({
  type: types.DISABLE_COMPANY_FAILED,
  payload: error,
});
//
// ─── ENABLE CURRENT COMPANY ACTIONS ──────────────────────────────────────────
//

export const EnableCompany = (id) => ({
  type: types.ENABLE_COMPANY,
  payload: id,
});
export const EnableCompanySuccess = (response) => ({
  type: types.ENABLE_COMPANY_SUCCESS,
  payload: response,
});
export const EnableCompanyFailed = (error) => ({
  type: types.ENABLE_COMPANY_FAILED,
  payload: error,
});

//
// ─── DELETE CURRENT COMPANY ACTIONS ─────────────────────────────────────────────────────
//

export const DeleteCompany = (id) => ({
  type: types.DELETE_COMPANY,
  payload: id,
});
export const DeleteCompanySuccess = (response) => ({
  type: types.DELETE_COMPANY_SUCCESS,
  payload: response,
});
export const DeleteCompanyFailed = (error) => ({
  type: types.DELETE_COMPANY_FAILED,
  payload: error,
});

//
// ─── SET DEFAULT COMPANY ─────────────────────────────────────────────────────
//

export const SetDefaultCompany = (company) => ({
  type: types.SET_DEFAULT_COMPANY,
  payload: company,
});

//
// ─── STAR COMPANY ─────────────────────────────────────────────────────
//

export const StarCompany = (list) => ({
  type: types.STAR_COMPANY,
  payload: list,
});
export const StarCompanySuccess = (response) => ({
  type: types.STAR_COMPANY_SUCCESS,
  payload: response,
});
export const StarCompanyFailed = (error) => ({
  type: types.STAR_COMPANY_FAILED,
  payload: error,
});

//
// ─── UN_STAR COMPANY ─────────────────────────────────────────────────────
//

export const UnStarCompany = (id) => ({
  type: types.UN_STAR_COMPANY,
  payload: id,
});
export const UnStarCompanySuccess = (response) => ({
  type: types.UN_STAR_COMPANY_SUCCESS,
  payload: response,
});
export const UnStarCompanyFailed = (error) => ({
  type: types.UN_STAR_COMPANY_FAILED,
  payload: error,
});

export const ClearCompanyList = () => ({
  type: types.CLEAR_COMAPANY_LIST,
});

export const SwitchCompany = (id) => ({
  type: types.SWITCH_COMAPANY,
  payload: id,
});
export const SwitchCompanySuccess = (response) => ({
  type: types.SWITCH_COMAPANY_SUCCESS,
  payload: response,
});
export const SwitchCompanyFailed = (error) => ({
  type: types.SWITCH_COMAPANY_FAILED,
  payload: error,
});
export const ClearCompanyResponse = (value) => ({
  type: types.CLEAR_COMPANY_RESPONSE,
});
export const FetchACompanyLogs = (companyId) => ({
  type: types.FETCH_A_COMPANY_LOGS,
  payload: companyId,
});
export const FetchACompanyLogsSuccess = (logs) => ({
  type: types.FETCH_A_COMPANY_LOGS_SUCCESS,
  payload: logs,
});
export const FetchACompanyLogsFailed = (error) => ({
  type: types.FETCH_A_COMPANY_LOGS_FAILED,
  payload: error,
});
export const ClearCompanyDetails = () => ({
  type: types.CLEAR_COMPANY_DETAILS,
});

export const UpdateCompanyFeature = (company) => ({
  type: types.UPDATE_COMPANY_FEATURE,
  payload: company,
});
export const UpdateCompanyFeatureSuccess = (response) => ({
  type: types.UPDATE_COMPANY_FEATURE_SUCCESS,
  payload: response,
});
export const UpdateCompanyFeatureFailed = (error) => ({
  type: types.UPDATE_COMPANY_FEATURE_FAILED,
  payload: error,
});

export const FetchCompanyFeatureList = (page, size, order, companyId) => ({
  type: types.FETCH_COMPANY_FEATURE_LIST,
  payload: {
    page,
    size,
    order,
    companyId,
  },
});

export const FetchCompanyFeatureListSuccess = (list) => ({
  type: types.FETCH_COMPANY_FEATURE_LIST_SUCCESS,
  payload: list,
});
export const FetchCompanyFeatureListFailed = (error) => ({
  type: types.FETCH_COMPANY_FEATURE_LIST_FAILED,
  payload: error,
});
export const UpdateCompanyDynamic = (company) => ({
  type: types.UPDATE_COMPANY_DYNAMIC,
  payload: company,
});
export const UpdateCompanyDynamicSuccess = (response) => ({
  type: types.UPDATE_COMPANY_DYNAMIC_SUCCESS,
  payload: response,
});
export const UpdateCompanyDynamicFailed = (error) => ({
  type: types.UPDATE_COMPANY_DYNAMIC_FAILED,
  payload: error,
});
export const ClearErrorResponse = () => ({
  type: types.CLEAR_ERROR_RESPONSE,
});
